import React, { useContext } from 'react';
import { DEFAULT_FEATURE_FLAGS } from './feature-flags';
export const TimeZoneContext = /*#__PURE__*/React.createContext('timeZone');
export const CentreContext = /*#__PURE__*/React.createContext(undefined);
export const CustomThemeContext = /*#__PURE__*/React.createContext({});
export const UserDeviceContext = /*#__PURE__*/React.createContext({
  isUsingTouch: false
});
export const BasicPageContext = /*#__PURE__*/React.createContext(false);
export const GetHrefContext = /*#__PURE__*/React.createContext(() => '');
/** TODO - remove this enzyme hack and refactor in React Testing Library
 * This test is skipped as part of REACT-18 and will be part of post-delivery tracked
 * in ticket DXP-737
 * eslint-disable-next-line jest/no-disabled-tests
 **/

// TODO: currently enzyme doesn't support useContext so the testing
// will not working when we use useContext inside the react component
// once this https://github.com/airbnb/enzyme/pull/2041 is released
// we can ditch this in the bin
export const useGetHrefContext = () => useContext(GetHrefContext);

// Typing Raven as `any` because getting the client and server types to work
// together seemed too much of a painful diversion. Intentionally did not
// suppress the lint warning to keep this as a visible issue to be addressed
// later
export const RavenContext = /*#__PURE__*/React.createContext(undefined);
export const ServerErrorContext = /*#__PURE__*/React.createContext(undefined);
export const AgentInfoContext = /*#__PURE__*/React.createContext({
  agent: '',
  isIPhone: false,
  isMobile: false
});
export const CountryContext = /*#__PURE__*/React.createContext('');
export const useCountryContext = () => useContext(CountryContext);
export const WhatsOnSeeMoreContext = /*#__PURE__*/React.createContext({});
export const FeatureFlagsContext = /*#__PURE__*/React.createContext(DEFAULT_FEATURE_FLAGS);
export const PromotionPositionContext = /*#__PURE__*/React.createContext(undefined);
export const LinkContext = /*#__PURE__*/React.createContext(() => null);
export const UserContext = /*#__PURE__*/React.createContext({
  user: undefined,
  loading: false
});
export const useUser = () => useContext(UserContext);
export const CentresContext = /*#__PURE__*/React.createContext([]);
export const NavContext = /*#__PURE__*/React.createContext(() => null);
export const AdTargetingContext = /*#__PURE__*/React.createContext({});